import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Icon, Segment, Table, Input, Divider, Card, Grid, Label } from 'semantic-ui-react';
import TargetLink from '../../components/target-link';
import DiscountCodesSelector from '../../components/discount-codes-selector';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const SHOPIFY_HELP_LINK = 'https://help.shopify.com/en/manual/discounts/create-discount-codes';
const DISCOUNT_HELP_LINK = 'https://help.dyzio.co/en/articles/5517378-shopify-integration';

const shopifyLogoStyle = {
  height: '1.2em',
};

const iconMarginLeftStyle = {
  marginLeft: 5,
};

const buttonStyles = {
  width: 'auto',
};

class ShopifyConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      discountCode: props.discountCode,
      commission: props.commission,
      isDiscountCodeEditing: false,
      isUrlEditing: false,
      isCommissionEditing: false,
      hideShopifyConfig: false,
      isUrlValid: true,
      isCommissionValid: true,
    };
  }

  persistShopifySettings = async shopifySettings => {
    const { discountCode, commission } = shopifySettings;
    const { saveShopifySetting, reloadShopifyOrders } = this.props;

    if (discountCode || _.isEqual(discountCode, '')) {
      await saveShopifySetting(shopifySettings);
      reloadShopifyOrders();
      this.toggleDiscountCodeInputState();
    }

    if (commission) {
      const {
        isCommissionValid,
      } = this.state;
      if (isCommissionValid) {
        await saveShopifySetting(shopifySettings);
        reloadShopifyOrders();
        this.setState({
          isCommissionEditing: false,
        });
      }
    }
  }

  onDiscountCodeChange = (e, { value }) => this.setState({
    discountCode: value,
  });

  onCommisionChange = (e, { value }) => this.setState({
    commission: value,
    isCommissionValid: (_.toNumber(value) <= 100) && (_.toNumber(value) >= 0),
  });

  toggleDiscountCodeInputState = () => this.setState({
    isDiscountCodeEditing: !this.state.isDiscountCodeEditing,
  });

  toggleCommissionInputState = () => this.setState({
    isCommissionEditing: !this.state.isCommissionEditing,
  });

  toggleShopifyConfig = () => this.setState({
    hideShopifyConfig: !this.state.hideShopifyConfig,
  });

  onDiscountCodeSelected = async dc => {
    const {
      discountCode,
    } = this.state;

    console.log(dc);

    const discountCodeArray = _.split(discountCode, ',');

    console.log(discountCodeArray);

    const isDiscountCodeSelected = _.find(discountCodeArray, item => (_.isEqual(item, dc)));
    console.log(isDiscountCodeSelected);

    let updatedDiscountCode = discountCode;

    if (!isDiscountCodeSelected) {
      if (discountCode) {
        updatedDiscountCode = `${discountCode},${dc}`;
      } else {
        updatedDiscountCode = dc;
      }
    }

    await this.persistShopifySettings({ discountCode: updatedDiscountCode });

    this.setState({ discountCode: updatedDiscountCode });
  }

  onTagUnselected = tagId => {
    const { tags } = this.state;
    const newTags = _.reject(tags, ['id', tagId]);
    this.setState({
      tags: newTags,
    });
  }

  removeDiscountCode = async (e, { key, value }) => {
    const {
      discountCode,
    } = this.state;

    console.log(key);
    console.log(value);

    const discountCodeArray = _.split(discountCode, ',');

    console.log(discountCodeArray);

    const updatedDiscountCodeArray = _.reject(discountCodeArray, dc => (_.isEqual(value, dc)));

    console.log(updatedDiscountCodeArray);

    let updatedDiscountCode = '';

    _.forEach(updatedDiscountCodeArray, (dc, i) => {
      updatedDiscountCode += updatedDiscountCodeArray[i] + (i === updatedDiscountCodeArray.length - 1 ? '' : ',');
    });

    console.log(updatedDiscountCode);

    await this.persistShopifySettings({ discountCode: updatedDiscountCode });

    this.setState({ discountCode: updatedDiscountCode });
  }

  render() {
    const {
      discountCode,
      commission,
      isCommissionEditing,
      hideShopifyConfig,
      isCommissionValid,
    } = this.state;

    const { editable } = this.props;

    console.log(this.state);

    const commisionInputActionProps = {
      icon: isCommissionEditing ? 'save' : 'pencil',
      onClick: isCommissionEditing ? () => this.persistShopifySettings({ commission }) : this.toggleCommissionInputState,
      disabled: isCommissionEditing && _.isEmpty(commission),
      color: isCommissionEditing ? 'pink' : 'green',
    };

    return (
      <Segment>
        <Card.Content>
          <Grid columns="2">
            <Grid.Row>
              <Grid.Column verticalAlign="middle">
                <h3><img
                  style={shopifyLogoStyle}
                  src="/icons/shopify.svg"
                  alt="Shopify"
                /> Shopify configuration
                { editable && <TargetLink href={DISCOUNT_HELP_LINK} renderIf>
                  <Icon name="info circle" color="green" style={iconMarginLeftStyle} />
                </TargetLink>}
                </h3>
              </Grid.Column>
              <Grid.Column textAlign="right">
                { hideShopifyConfig
                  ? <Button floated="right" icon="chevron down" onClick={this.toggleShopifyConfig} style={buttonStyles} />
                  : <Button floated="right" icon="chevron up" onClick={this.toggleShopifyConfig} style={buttonStyles} />
                }
              </Grid.Column>
            </Grid.Row>
          </Grid>

        </Card.Content>
        <Divider />
        { editable && !hideShopifyConfig && <Card.Content>
          <p>
              Add a Shopify discount code and / or a shareable URL to this influencer.  These
              codes can be created and accessed in the 'Discounts' section of your Shopify
              account. <TargetLink href={SHOPIFY_HELP_LINK} renderIf>
                  Click here
            </TargetLink> to learn more.
            <br />
            <br />
            You can also add a Commission percentage,
            that will be applied to any sales the influencers makes,
            via this Shopify URL or discount code. The influencer will be able to see the commission
            they have earned when they log into Dyzio.
            <br />
            <br />
            All Shopify data linked to this code and URL will be available in your Dyzio Shopify report.
          </p>
        </Card.Content>}
        { !hideShopifyConfig &&
        <Table>
          { editable && <Table.Row>
            <Table.Cell width={2}>Add Discount Code</Table.Cell>
            <Table.Cell width={14}>
              <DiscountCodesSelector
                onSelected={this.onDiscountCodeSelected}
              />
            </Table.Cell>
          </Table.Row>}
          { !editable && <Table.Row />}
          <Table.Row>
            <Table.Cell width={2}>Discount Codes:</Table.Cell>
            <Table.Cell width={14}>
              <Table celled fixed singleLine basic="very" size="small" textAlign="center">
                <Table.Body>
                  {discountCode && _.map(_.split(discountCode, ','), dc => {
                    if (!_.isEqual(dc, ' ')) {
                      return (
                        <Table.Row >
                          <Table.Cell width={2}>
                            <Label
                              name={dc}
                              value={dc}
                            >
                              {dc}
                            </Label>
                          </Table.Cell>
                          <Table.Cell width={4}>{`https://mefitpro.myshopify.com/discount/${dc}`}</Table.Cell>
                          { editable && <Table.Cell width={1}>
                            <Button
                              size="mini"
                              key={dc}
                              onClick={this.removeDiscountCode}
                              value={dc}
                              compact
                              circular
                              icon="delete"
                            />
                          </Table.Cell>}

                          { !editable && <Table.Cell width={1}>
                            <CopyToClipboard
                              text={`https://mefitpro.myshopify.com/discount/${dc}`}
                            // onCopy={() => this.setState({ bioCopied: true, storyCopied: false })}
                            >
                              {/* <Button icon={bioCopied ? 'checkmark' : 'copy'} color="pink" /> */}
                              <Button icon="copy" color="pink" />
                            </CopyToClipboard>
                          </Table.Cell>}
                        </Table.Row>);
                    }
                    return null;
                  })
                  }
                </Table.Body>
              </Table>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={2}>Commission %</Table.Cell>
            { editable && <Table.Cell width={14}>
              <Input
                fluid
                type="number"
                onChange={this.onCommisionChange}
                disabled={!isCommissionEditing}
                defaultValue={commission}
                value={commission}
                action={commisionInputActionProps}
                error={!isCommissionValid}
              />
              {
                (!isCommissionValid && commission) &&
                <Card.Content meta textAlign="center">
                  <Label color="red" basic><Icon name="ban" color="red" />Must be a percentage between 0 - 100</Label>
                </Card.Content>
              }
            </Table.Cell>}
            { !editable && <Table.Cell width={14}>
              <Input
                fluid
                type="number"
                disabled={!editable}
                defaultValue={commission}
                value={commission}
              />
            </Table.Cell>}
          </Table.Row>
        </Table>}
      </Segment>
    );
  }
}

ShopifyConfig.propTypes = {
  discountCode: PropTypes.string.isRequired,
  commission: PropTypes.string.isRequired,
  editable: PropTypes.bool.isRequired,
};

ShopifyConfig.defaultProps = {
  editable: false,
};

export default ShopifyConfig;



/** WEBPACK FOOTER **
 ** ./src/components/shopify-config/index.js
 **/